import React, {useState, useEffect} from 'react'
import { 
    Layout,
    Col, 
    Row,
    Button,
    Select,
    Space,
    DatePicker,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import BtnExcel from '../../Components/BtnExcel';
import { getTodayDateISO, formatAmount, capitalizeEachWord } from '../../Utils/Common';

const { Option } = Select;
const { RangePicker } = DatePicker;

const MonthlyManagementIncome = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  // const [billingAmount, setBillingAmount] = useState(0)
  // const [income, setIncome] = useState(0)
  // const [expense, setExpense] = useState(0)
  const [netIncome, setNetIncome] = useState(0)
  const [excelData, setExcelData] = useState([])
  const [receivableData, setReceivableData] = useState([])
  const [propertyData, setPropertyData] = useState([])
  const [ownerData, setOwnerData] = useState([])
  const [rentaUnitData, setRentalUnitData] = useState([])
  const [parkingUnitData, setParkingUnitData] = useState([])
  const startDate = dayjs().startOf('month');
  const endDate = dayjs().endOf('month');

  const [filterConfig, setFilterConfig] = useState({
    start_date: dayjs(startDate).format('YYYY-MM-DD'),
    end_date: dayjs(endDate).format('YYYY-MM-DD'),
    rental_unit_id: '',
    parking_unit_id: '',
    property_id: '',
    owner_id: '',
    page: 1,
  })

  const handleButtonClick = (id) => {
    const url = '/preview-billing/tenant/' + id;
    window.open(url, '_blank');
  };

  async function fetchManagementData() {
    setIsLoading(true);
    const response = await UseGetRequest("payments/management_monthly_income", filterConfig);
    if (response.data) {
      const data = response?.data?.data?.map((data) => ({
        billing_date: data.billing_date,
        billing_no: <Button className='mb-2' onClick={() => handleButtonClick(data.billing_id)}>{data.billing_no}</Button>,
        type: data.type ? capitalizeEachWord(data.type) : '',
        concatenated_property: data.concatenated_property && capitalizeEachWord(data.concatenated_property),
        owner_name: data.owner_name && capitalizeEachWord(data.owner_name),
        amount_paid: data.amount_paid ? formatAmount(data.amount_paid) : '',
        management_fee: data.management_fee ? formatAmount(data.management_fee) : '',
        total_income: data.total_income ? formatAmount(data.total_income) : '',
        agent_fee: data.agent_fee ? formatAmount(data.agent_fee) : '',
      }))
   
      // setBillingAmount(response?.data?.total_billing_amount ? formatAmount(response?.data?.total_billing_amount) : 0)
      // setIncome(response?.data?.total_income ? formatAmount(response?.data?.total_income) : 0)
      // setExpense(response?.data?.total_expense ? formatAmount(response?.data?.total_expense) : 0)
      setNetIncome(response?.data?.net_income ? formatAmount(response?.data?.net_income) : 0)
      setReceivableData(data);
      setPageSize(response?.data?.size)
    } else {
      // setBillingAmount(0)
      // setIncome(0)
      // setExpense(0)
      setNetIncome(0)
      setReceivableData([])
      setPageSize('')
    }
    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true);
    const response = await UseGetRequest("payments/management_monthly_income", 
      {
        start_date: filterConfig.start_date,
        end_date: filterConfig.end_date,
        rental_unit_id: filterConfig.rental_unit_id,
        parking_unit_id: filterConfig.parking_unit_id,
        property_id: filterConfig.property_id,
        owner_id: filterConfig.owner_id,
      }
    );
    if (response.data) {
      const excel = response?.data?.data?.map((data) => ({
        billing_date: data.billing_date,
        billing_no: data.billing_no,
        type: data.type ? capitalizeEachWord(data.type) : '',
        concatenated_property: data.concatenated_property && capitalizeEachWord(data.concatenated_property),
        owner_name: data.owner_name && capitalizeEachWord(data.owner_name),
        agent_fee: data.agent_fee ? formatAmount(data.agent_fee) : '',
        management_fee: data.management_fee ? formatAmount(data.management_fee) : '',
        total_income: data.total_income ? formatAmount(data.total_income) : '',
      }))
   
      setExcelData(excel)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  async function fetchOwnerData() {
    const response = await UseGetRequest("owners/get");
    if (response?.data) {
      setOwnerData(response?.data?.data);
    } else {
      setOwnerData([])
    }

  }

  async function fetchPropertyData() {
    const response = await UseGetRequest("properties/get");
    if (response?.data) {
      setPropertyData(response?.data?.data);
    } else {
      setPropertyData([])
    }
  }

  async function fetchUnitData() {
    const response = await UseGetRequest("rental_units/get");
    if (response?.data) {
      setRentalUnitData(response?.data?.data);
    } else {
      setRentalUnitData([])
    }
  }

  async function fetchParkingData() {
    const response = await UseGetRequest("parking_units/get");
    if (response?.data) {
      setParkingUnitData(response?.data?.data);
    } else {
      setParkingUnitData([])
    }
  }

  function ActionBtn(row) {
    return (
      <span className='center'>
        <Button 
          className='button-color btn-header' 
          type="primary"
          onClick={() => navigate('/owner-income/preview/' + row.row.type + '/' + row.row.unit_id + '/' + row.row.billing_no)}
        >
          View
        </Button>
      </span>
    );
  }

  const onSearchOwner = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        owner_id: e || '',
        page: 1,
      }
    ));
  };

  const onSearchProperty = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        property_id: e || '',
        page: 1,
      }
    ));
  };
  
  const onSearchUnit = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        rental_unit_id: e || '',
        type: 'rental',
        page: 1,
      }
    ));
  };
  
  const onSearchParking = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        parking_unit_id: e || '',
        type: 'parking',
        page: 1,
      }
    ));
  };

  const onSearchDate = (e) => {
    if(e){
     setFilterConfig((prev) => (
       {
         ...prev,
         start_date: e[0].format("YYYY-MM-DD"),
         end_date: e[1].format("YYYY-MM-DD"),
         page: 1,
       }
     ));
    } else {
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: '',
          end_date: '',
          page: 1,
        }
      ));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchManagementData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  useEffect(() => {
    fetchPropertyData();
    fetchOwnerData();
    fetchUnitData();
    fetchParkingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout className='page'>
      <Navbar navKey={'management_income_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={19} className='header-container'>
            MANAGEMENT INCOME
          </Col>
          <Col span={5} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "Billing Date",
                  "Billing Number",
                  "Type",
                  "Building & Unit Number",
                  "Owner",
                  "Amount",
                  "Management Fee",
                  "Totan Income",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Management_Income_${getTodayDateISO()}.xlsx`}
              />
            </Space>
          </Col>
        </Row>
        <Row className='ms-4 mb-4'>
          <Space className='responsive-inline'>
            <Select 
              placeholder="Search Property"
              className='select-field responsive-header-input'
              onChange={(e) => onSearchProperty(e)}
              showSearch
              allowClear
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {propertyData.map(month => (
                <Option key={month.id} value={month.id}>{month.name}</Option>
              ))}
            </Select>
            <Select 
              placeholder="Search Rental Unit"
              className='select-field responsive-header-input'
              onChange={(e) => onSearchUnit(e)}
              showSearch
              allowClear
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {rentaUnitData.map(month => (
                <Option key={month.id} value={month.id}>{month.name}</Option>
              ))}
            </Select>
            <Select 
              placeholder="Search Parking Unit"
              className='select-field responsive-header-input'
              onChange={(e) => onSearchParking(e)}
              showSearch
              allowClear
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {parkingUnitData.map(month => (
                <Option key={month.id} value={month.id}>{month.name}</Option>
              ))}
            </Select>
            <Select 
              placeholder="Search Owner"
              className='select-field responsive-header-input'
              onChange={(e) => onSearchOwner(e)}
              showSearch
              allowClear
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {ownerData.map(month => (
                <Option key={month.id} value={month.id}>{month.name}</Option>
              ))}
            </Select>
            <RangePicker 
              renderExtraFooter={() => 'extra footer'}
              className='responsive-header-input'
              onChange={(e)=>onSearchDate(e)}
              allowClear
              defaultValue={[
                dayjs(startDate, 'YYYY/MM/DD'),
                dayjs(endDate, 'YYYY/MM/DD')
              ]}
            />
          </Space>
        </Row>
        <Row gutter={[16, 16]} className='mx-4'>
          {/* <Col xs={24} sm={24} md={6} lg={6} xl={6} className='amount-total-two' align='left'>
              Total Billing Amount: {billingAmount}
          </Col>
    
          <Col xs={24} sm={24} md={6} lg={6} xl={6} className='amount-total-two' align='left'>
              Total Income: {income}
          </Col>
    
          <Col xs={24} sm={24} md={6} lg={6} xl={6} className='amount-total-two' align='left'>
              Expense: {expense}
          </Col> */}
    
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='amount-total-two' align='right'>
              Net Income: {netIncome}
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24}>
            <AntDTable
              tableHeaders={[
                "Billing Date",
                "Billing Number",
                "Type",
                "Property/Unit",
                "Owner",
                "Agent Fee",
                "Management Fee",
                // "Totan Income",
              ]}
              headerSelector={[
                "billing_date",
                "billing_no",
                "type",
                "concatenated_property",
                "owner_name",
                "agent_fee",
                "management_fee",
                // "total_income",
              ]}
              tableData={receivableData}
              withAction={false}
              ActionBtn={(row) => ActionBtn(row)}
              loading={isLoading}
              tablePages={10}
              handleTableChange={handleTableChange}
              filterConfig={filterConfig}
              totalSize={pageSize}
              isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default MonthlyManagementIncome
